import { isValidLocalResult } from '../../local-game-result.js';

function legacyKey(gameType) {
  return `ivs-board-${gameType}-state`;
}

function scopedKey(gameType, mode) {
  return `ivs-board-${gameType}-${mode}-state`;
}

export function saveLocalGameSnapshot({ storage = globalThis.localStorage, gameType, mode, game, result }) {
  if (!storage || !gameType || !game || mode === 'online') return;

  storage.setItem(scopedKey(gameType, mode), JSON.stringify({
    version: 2,
    moves: game.history.map(entry => ({
      from: entry.move.from,
      to: entry.move.to,
      promotion: entry.move.promotion || null
    })),
    result
  }));
}

export function loadLocalGameSnapshot({
  storage = globalThis.localStorage,
  gameType,
  mode,
  createEngine
}) {
  const makeNew = () => createEngine(gameType);
  if (!storage) return { game: makeNew(), result: null };

  try {
    const key = scopedKey(gameType, mode);
    let raw = storage.getItem(key);

    if (!raw) {
      const oldKey = legacyKey(gameType);
      const legacy = storage.getItem(oldKey);
      if (legacy) {
        raw = legacy;
        storage.setItem(key, legacy);
        storage.removeItem(oldKey);
      }
    }

    if (!raw) return { game: makeNew(), result: null };

    const data = JSON.parse(raw);
    if (!Array.isArray(data?.moves)) return { game: makeNew(), result: null };

    const game = makeNew();
    for (const move of data.moves) {
      const ok = gameType === 'chess'
        ? game.move(move.from, move.to, move.promotion || 'q')
        : game.move(move.from, move.to);
      if (!ok) return { game: makeNew(), result: null };
    }

    return {
      game,
      result: isValidLocalResult(data.result) ? data.result : null
    };
  } catch {
    return { game: makeNew(), result: null };
  }
}

export function isLocalGameFinished(status, manualResult) {
  if (!status) return true;
  return Boolean(
    manualResult ||
    status.finished ||
    status.checkmate ||
    status.draw ||
    status.stalemate ||
    status.fifty ||
    status.repetition ||
    status.insufficient
  );
}
